<template>
  <div class="padding-xl">
    <el-steps :active="3" align-center class="padding-tb-xl" process-status="finish">
      <el-step title="选择订户类型"></el-step>
      <el-step title="填写征订单"></el-step>
      <el-step title="订单支付"></el-step>
      <el-step title="发票开具"></el-step>
    </el-steps>
    <div class="padding-lr shadow-warp">
      <div class="flex justify-between align-center text-lg text-bold">
        <div>
          订单流水号：{{ order.no }}
        </div>
        <div class="padding-tb">开票金额：<span class="text-red">¥ {{ order.amount }}</span> 元</div>
      </div>
    </div>
    <div class="flex justify-start align-center solid-bottom padding-top">
      <div class="nav padding-right-xl">
        <div style="cursor:pointer;" class="cu-item text-lg" :class="index==TabCur?'text-red cur':''"
             v-for="(item,index) in tabs" :key="index"
             @click="tabSelect" :data-id="index">
          {{ item }}
        </div>
      </div>
      <div class="padding-left flex justify-start align-end">
        <el-switch v-model="isSaveInvoice"></el-switch>
        <div class="text-sm padding-left-sm">保存为默认发票信息</div>
      </div>
    </div>
    <div class="padding">
      <div class="flex align-center" v-if="serverConfig.invoiceSpecialEnabled===true && TabCur === 0">
        <div class="info-label">
          <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
          开票类型：
        </div>
        <div>
          <el-select v-model="invoice.invoiceType" size="small" style="width:197px" placeholder="请选择">
            <el-option label="电子普通发票（数电普票）" value="电子普通发票（数电普票）"></el-option>
            <el-option label="数电专票" value="数电专票"></el-option>
          </el-select>
        </div>
      </div>
      <div class="flex align-center padding-top">
        <div class="flex justify-start align-center">
          <div class="info-label">
            <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
            {{ TabCur === 1 ? '姓名' : '单位名称' }}：
          </div>
          <div>
            <el-input v-model="invoice.invoiceOrg" size="small"></el-input>
          </div>
        </div>
        <div v-if="TabCur!==1" class="flex justify-start align-center padding-left-xl">
          <div class="info-label">
            <div class="text-red text-xs"><i
              :class="invoiceConfig.taxNumRequired===true? 'cuIcon-favorfill':'cuIcon-favor'"></i></div>
            税号：
          </div>
          <div>
            <el-input v-model="invoice.invoiceTaxNum" size="small"></el-input>
          </div>
        </div>
      </div>
      <div v-if="TabCur!==2" class="flex align-center padding-top">
        <div class="flex justify-start align-center">
          <div class="info-label">
            <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
            接收手机：
          </div>
          <div>
            <el-input v-model="invoice.invoiceReceivePhone" size="small"></el-input>
          </div>
        </div>
        <div class="flex justify-start align-center padding-left-xl">
          <div class="info-label">
            <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
            接收邮箱：
          </div>
          <div>
            <el-input v-model="invoice.invoiceMail" size="small"></el-input>
          </div>
        </div>
      </div>
      <div class="flex align-center padding-top" v-if="TabCur!==1">
        <div class="flex justify-start align-center">
          <div class="info-label">
            <div v-if="TabCur===2" class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
            开户银行：
          </div>
          <div>
            <el-input v-model="invoice.invoiceBank" size="small"></el-input>
          </div>
        </div>
        <div class="flex justify-start align-center padding-left-xl">
          <div class="info-label">
            <div v-if="TabCur===2" class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
            银行帐号：
          </div>
          <div>
            <el-input v-model="invoice.invoiceBankAccount" size="small"></el-input>
          </div>
        </div>
      </div>
      <div class="flex align-center padding-top" v-if="TabCur!==1">
        <div class="flex justify-start align-center">
          <div class="info-label">
            <div v-if="TabCur===2" class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
            注册电话：
          </div>
          <div>
            <el-input v-model="invoice.invoicePhone" size="small"></el-input>
          </div>
        </div>
      </div>
      <div class="flex align-center padding-top" v-if="TabCur!==1">
        <div class="flex justify-start align-center">
          <div class="info-label">
            <div v-if="TabCur===2" class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
            注册地址：
          </div>
          <div>
            <el-input v-model="invoice.invoiceOrgAddress" type="textarea" size="small"
                      style="min-width: 400px;"></el-input>
          </div>
        </div>
      </div>
      <div class="flex align-center padding-top">
        <div class="flex justify-start align-center">
          <div class="info-label">发票备注：</div>
          <div>
            <el-input v-model="invoice.invoiceRemark" type="textarea" size="small"
                      style="min-width: 400px;"></el-input>
          </div>
        </div>
      </div>
    </div>
    <div class="padding-lr" v-if="TabCur===2">
      <el-divider content-position="left"><span class="text-red text-lg">发票邮寄信息</span></el-divider>
      <div class="flex align-center padding-top">
        <div class="flex align-center">
          <div class="info-label">
            <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
            收件单位：
          </div>
          <div>
            <el-input v-model="invoice.addressOrg" size="small"></el-input>
          </div>
        </div>
        <div class="flex justify-start align-center padding-left-xl">
          <div class="info-label">
            <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
            联系电话：
          </div>
          <div>
            <el-input v-model="invoice.addressPhone" size="small"></el-input>
          </div>
        </div>
      </div>
      <div class="flex align-center padding-top">
        <div class="flex justify-start align-center">
          <div class="info-label">
            <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
            收件人：
          </div>
          <div>
            <el-input v-model="invoice.addressPerson" size="small"></el-input>
          </div>
        </div>
        <div class="flex justify-start align-center padding-left-xl">
          <div class="info-label">
            <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
            邮编：
          </div>
          <div>
            <el-input v-model="invoice.addressZip" size="small"></el-input>
          </div>
        </div>
      </div>
      <div class="flex align-center padding-top">
        <div class="info-label">
          <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
          收货地址：
        </div>
        <div>
          <v-region v-model="addressSelected"></v-region>
        </div>
      </div>
      <div class="flex align-center padding-tb">
        <div class="flex justify-start align-center">
          <div class="info-label">
            <div class="text-red text-xs"><i class="cuIcon-favorfill"></i></div>
            街道：
          </div>
          <div>
            <el-input v-model="invoice.addressStreet" type="textarea" style="min-width: 400px;" size="small"></el-input>
          </div>
        </div>
      </div>
    </div>
    <div class="padding-xs"></div>
    <div class="padding-lg text-center">
      <button class="cu-btn line-red round lg margin-lr" style="width:200px"
              @click="$router.push({ path: '/pages/order-list' })">暂不开票
      </button>
      <button class="cu-btn bg-red round lg margin-lr" style="width:200px" @click="doSubmit">确认开票</button>
    </div>
    <el-dialog :show-close="false" :close-on-click-modal="false"
               title="税号未填写提示"
               :visible.sync="taxDialogShow"
               width="30%">
      <span>确定贵单位无税号？（除部队等特殊单位外，税号为重要必填开票信息）请确认。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="taxDialogShow = false">去填写</el-button>
        <el-button type="primary" @click="ignoreTaxSubmit">继续提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import bs from '@/services/data/bs'
import config from '../../public/config/config'
import { Message } from 'element-ui'

export default {
  name: 'invoice',
  data () {
    return {
      invoiceConfig: config.invoice,
      serverConfig: config.serverConfig,
      isSaveInvoice: true,
      addressSelected: {
        province: '',
        city: '',
        area: '',
        town: ''
      },
      user: {},
      invoice: {
        type: 0,
        invoiceType: '电子普通发票（数电普票）',
        invoiceOrg: '',
        invoiceTaxNum: '',
        invoiceBankAccount: '',
        invoiceBank: '',
        invoiceOrgAddress: '',
        invoicePhone: '',
        invoiceMail: '',
        invoiceRemark: '',
        invoiceReceivePhone: '',
        addressOrg: '',
        addressPhone: '',
        addressArea: '',
        addressStreet: '',
        addressZip: '',
        addressPerson: ''
      },
      tabs: config.invoiceTypes,
      TabCur: 0,
      scrollLeft: 0,
      taxDialogShow: false
    }
  },
  watch: {
    'invoice.invoiceReceivePhone' (val) {
      if (val) {
        val = val.replace(/[^0-9]/ig, '')
        if (val.length > 11) {
          val = val.slice(0, 11)
        }
        this.invoice.invoiceReceivePhone = val
      }
    }
  },
  created () {
    this.user = JSON.parse(sessionStorage.getItem('user'))
    if (sessionStorage.getItem('order')) {
      this.order = JSON.parse(sessionStorage.getItem('order'))
      if (this.order.list && this.order.list.length > 0) {
        const firstDetail = this.order.list[0]
        if (firstDetail.invoiceOrg) {
          this.invoice.invoiceOrg = firstDetail.invoiceOrg
        }
        if (firstDetail.invoiceTaxTin) {
          this.invoice.invoiceTaxNum = firstDetail.invoiceTaxTin
        }
        if (firstDetail.invoicePhone) {
          this.invoice.invoiceReceivePhone = firstDetail.invoicePhone
        }
        if (firstDetail.invoiceEmail) {
          this.invoice.invoiceMail = firstDetail.invoiceEmail
        }
      }
      if (this.order && this.order.subCategory && this.order.subCategory === '单位') {
        this.tabs = [this.tabs[0]]
      }
      if (this.order.invoice) {
        this.invoice = this.order.invoice
        const areas = this.invoice.addressArea.split(',', -1)
        this.addressSelected.province = areas[0]
        this.addressSelected.city = areas[1]
        this.addressSelected.area = areas[2]
      } else {
        this.invoice.orderId = this.order.id
        if (this.user) {
          this.invoice.addressOrg = this.user.addressOrg
          this.invoice.addressPhone = this.user.addressPhone
          this.invoice.addressStreet = this.user.addressStreet
          this.invoice.addressZip = this.user.addressZip
          this.invoice.addressPerson = this.user.addressPerson
          if (this.user.addressArea) {
            this.invoice.addressArea = this.user.addressArea
            const areas = this.user.addressArea.split(',', -1)
            this.addressSelected.province = areas[0]
            this.addressSelected.city = areas[1]
            this.addressSelected.area = areas[2]
          }
          this.invoice.invoiceOrg = this.user.invoiceOrg
          this.invoice.invoiceTaxNum = this.user.invoiceTaxNum
          this.invoice.invoiceBankAccount = this.user.invoiceBankAccount
          this.invoice.invoiceBank = this.user.invoiceBank
          this.invoice.invoiceOrgAddress = this.user.invoiceOrgAddress
          this.invoice.invoicePhone = this.user.invoicePhone
          this.invoice.invoiceMail = this.user.invoiceMail
          this.invoice.invoiceReceivePhone = this.user.invoiceReceivePhone
        }
      }
    }
  },
  methods: {
    tabSelect (e) {
      this.TabCur = parseInt(e.currentTarget.dataset.id)
      this.scrollLeft = (e.currentTarget.dataset.id - 1) * 60
      this.invoice.invoiceType = (this.TabCur !== 2 ? '增值税普通电子发票' : '专票')
      this.invoice.type = this.TabCur
    },
    doSubmit () {
      if (this.validForm()) {
        if (this.TabCur !== 1 && (!this.invoice.invoiceTaxNum || this.invoice.invoiceTaxNum.trim() === '')) {
          this.taxDialogShow = true
        } else {
          this.sendRequest()
        }
      }
    },
    ignoreTaxSubmit () {
      this.taxDialogShow = false
      this.sendRequest()
    },
    sendRequest () {
      this.invoice.addressArea = this.addressSelected.province + ',' + this.addressSelected.city + ',' + this.addressSelected.area
      bs.order.invoice(this.order.id, this.isSaveInvoice, this.invoice, (res) => {
        if (res.code === 200) {
          this.$alert(this.TabCur === 0 ? '您的电子发票已经开具，请注意查收短信和邮箱！' : '您的专票申请已接收，请注意查看开票状态！', '开票成功', {
            confirmButtonText: 'OK',
            callback: action => {
              this.$router.push({ path: '/pages/order-list' })
            }
          })
        } else {
          Message({
            message: res.data,
            type: 'error',
            duration: 3 * 1000
          })
        }
      })
    },
    validForm () {
      if (!this.invoice.invoiceOrg || this.invoice.invoiceOrg.trim() === '') {
        this.$message.error((this.TabCur === 1 ? '姓名' : '单位名称') + '不能为空')
        return false
      }
      if (this.invoiceConfig.taxNumRequired === true && (!this.invoice.invoiceTaxNum || this.invoice.invoiceTaxNum.trim() === '')) {
        this.$message.error('请输入税号')
        return false
      }
      if (this.TabCur !== 2) {
        if (!this.invoice.invoiceReceivePhone || this.invoice.invoiceReceivePhone.trim() === '' || this.invoice.invoiceReceivePhone.trim().length !== 11) {
          this.$message.error('请输入11位接收手机号码')
          return false
        }
        if (!this.invoice.invoiceMail || this.invoice.invoiceMail.trim() === '') {
          this.$message.error('接收邮箱不能为空')
          return false
        }
      } else {
        if (!this.invoice.invoiceBank || this.invoice.invoiceBank.trim() === '') {
          this.$message.error('开户银行不能为空')
          return false
        }
        if (!this.invoice.invoiceBankAccount || this.invoice.invoiceBankAccount.trim() === '') {
          this.$message.error('银行帐号不能为空')
          return false
        }
        if (!this.invoice.invoicePhone || this.invoice.invoicePhone.trim() === '') {
          this.$message.error('注册电话不能为空')
          return false
        }
        if (!this.invoice.invoiceOrgAddress || this.invoice.invoiceOrgAddress.trim() === '') {
          this.$message.error('注册地址不能为空')
          return false
        }
        if (!this.invoice.addressOrg || this.invoice.addressOrg.trim() === '') {
          this.$message.error('收件单位不能为空')
          return false
        }
        if (!this.invoice.addressPhone || this.invoice.addressPhone.trim() === '') {
          this.$message.error('联系电话不能为空')
          return false
        }
        if (!this.invoice.addressPerson || this.invoice.addressPerson.trim() === '') {
          this.$message.error('收件人不能为空')
          return false
        }
        if (!this.invoice.addressZip || this.invoice.addressZip.trim() === '') {
          this.$message.error('邮编不能为空')
          return false
        }
        if (this.addressSelected.area.trim() === '' || this.addressSelected.area === null) {
          this.$message.error('收货地址请选到区县')
          return false
        }
        if (!this.invoice.addressStreet || this.invoice.addressStreet.trim() === '') {
          this.$message.error('街道不能为空')
          return false
        }
      }
      return true
    }
  }
}
</script>

<style scoped>
.info-label {
  width: 90px;
  padding: 2px 0;
  text-align: right;
  display: flex;
  justify-content: flex-end;
}

.info-label div {
  padding-top: 3px;
  padding-right: 2px;
}

.view-label {
  min-width: 200px;
}
</style>
